import React from "react";
import FieldRenderer from "./FieldRenderer";
import { Typography, Divider } from "antd";

const { Title } = Typography;

export default function ProductionDetails({ fields, categoryId, allCategoryData }) {
	return (
		<div id="product">
			<Title level={5} style={{ fontSize: 16, marginBottom: "2vh" }}>
				4. Production Details
			</Title>
			<FieldRenderer fields={fields} categoryId={categoryId} allCategoryData={allCategoryData} />
			<Divider />
		</div>
	);
}
